<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label> 
        {{ title || 'input-city' | translate }}
      </mat-label>
      <input
        type="text"
        matInput
        [required]="required"
        [disabled]="disabled"
        [matAutocomplete]="autoComplete"
        formControlName="name"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let city of cities"
          (onSelectionChange)="handleCityChange($event, city)"
          [value]="city.name"
          class="autocomplete"
        >
          {{ city.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ requiredText || "required-city" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
